import { DataService } from './../../service/data.service';
import { CatalogProductDependency } from './../../model/CatalogProduct';
import { CatalogService } from './../../service/catalog.service';
import { EventService } from './../../service/event.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CatalogProduct } from '../../model/CatalogProduct';
import { Subscription, } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';
import { CatalogComponent } from '../catalog/catalog.component';
import { Modal } from '../controls/modal/modal.service';
import { Tab, TabAlignment, TabColor } from '../controls/tabs/tabs.component';
import { Events } from 'src/app/service/websocket.service';

export class DetailsTableColumn {
  productName: string;
  subColumns: DetailsTableSubColumn[];
}

export class DetailsTableSubColumn {
  fullName: string;
  shortName: string;
}

@Component({
    selector: 'app-catalog-details',
    templateUrl: './catalog-details.component.html',
    styleUrls: ['./catalog-details.component.css'],
    standalone: false
})
export class CatalogDetailsComponent extends CatalogComponent implements OnInit {
  product: CatalogProduct = new CatalogProduct();
  productName: string;
  version: string;
  dependencies: Record<string, CatalogProductDependency[]>;
  prefixMap: Record<string, string[]>;
  columns : DetailsTableColumn[] = [];
  activeTab: number = 0;
  activeTabText: string = "";
  activeTabId: string = "";
  isDownload: boolean = false;
  identifier: string = "";

  dependencyTabs: Tab[] = [];
  TabColor = TabColor;
  TabAlignment = TabAlignment;

  solutionInfoSubscription: Subscription;
  routerSubscription: Subscription;


  constructor(public catalogSrv: CatalogService, public eventService: EventService, public router: Router,
    public dataSrv: DataService, public route: ActivatedRoute, public modal: Modal, public el: ElementRef) {
    super(catalogSrv, eventService, router, dataSrv, route, modal, el);
  }

  ngOnInit(): void {
    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.isManifestUpdating = newSolutionInfo.manifestStatus.isUpdating;
      this.isSapMode = newSolutionInfo.isSModeEnabled;
      if (this.routerSubscription == undefined) {
        this.initView();
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      }
    });
  }

  initView(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.indexOf("/download") > 0) {
          this.isDownload = true;
        } else if (event.url.indexOf("/details") > 0) {
          this.productName = this.route.snapshot.paramMap.get("product");
          this.version = this.route.snapshot.paramMap.get("version");
          this.isDownload = false;
          if (this.productName != "") {
            this.setDetails();
          }
        } else {
          this.productName = "";
          this.version = "";
        }

      }
    });

    if (this.router.url.indexOf("/download") > 0) {
      this.isDownload = true;
    }

    if (this.router.url.indexOf("/download") == -1) {
      this.productName = this.route.snapshot.paramMap.get("product");
      this.version = this.route.snapshot.paramMap.get("version");
      this.setDetails();
    }
  }

  ngOnDestroy(): void {
    this.productName = "";
    this.version = "";
    if (this.solutionInfoSubscription != undefined) {
      this.solutionInfoSubscription.unsubscribe();
    }
    if (this.routerSubscription != undefined) {
      this.routerSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  onSelectedTabChange(selectedIndex: number) {
    var tab: any = this.dependencyTabs[selectedIndex];
    this.identifier = "dependency-" + tab.text.replaceAll(" ", "-").trim();
    this.activeTabId = tab.id;
    this.activeTabText = tab.text;
    this.activeTab = selectedIndex;
    if(this.activeTabId !== "Overview"){
      this.setColumns(this.activeTabText);
    }
  }

  getUniqueDependencies(category: string){
    let depList = [];
    for(let i = 0; i < Object.keys(this.dependencies[category]).length; i++){
      let key = Object.keys(this.dependencies[category])[i];
      this.dependencies[category][key].forEach((dep)=>{
        if(depList.indexOf(dep.displayName) < 0){
          depList.push(dep.displayName);
        }
      });
    }
    depList.sort((a, b) => (a > b ? 1 : -1));
    return depList;
  }

  isDependencySupported(category: string, component: string, product: string, version: string){
    let depList:any[] = (this.dependencies[category][component].filter((dep) => {
      return (dep.productName  == product && dep.version == version);
    }));
    return depList.length > 0;
  }

  setColumns(category: string) {
    let tmpColumn: DetailsTableColumn;
    this.columns = [];
    Object.keys(this.prefixMap[category]).forEach(productName=>{
      tmpColumn = new DetailsTableColumn();
      tmpColumn.productName = productName;
      tmpColumn.subColumns = [];
      for(let i = 0; i < this.prefixMap[category][productName].length; i++){
        let subColumn: DetailsTableSubColumn = new DetailsTableSubColumn();
        subColumn.fullName = this.prefixMap[category][productName][i];
        subColumn.shortName = this.prefixMap[category][productName][i];
        tmpColumn.subColumns.push(subColumn);
      }
      this.columns.push(tmpColumn);
    });
  }

  private setDetails(): void {
    this.dependencies = undefined;
    this.catalogSrv.getProductVersion(decodeURIComponent(this.productName)).pipe(
      tap(resp => {
        resp.body.forEach((prod) => {
          if (prod.product_uid === this.version) {
            this.product = prod;
            this.dataSrv.sendData(this.product);
            return;
          }
        });
      }),
      switchMap(() => this.catalogSrv.getDependencies(this.version).pipe(
        tap((resp: any) => {
          this.dependencyTabs = [];
          this.activeTab = 0;
          this.dependencyTabs.push(new Tab('Overview', "Overview", undefined, true));
          this.dependencies = resp.body.dependencies;
          this.prefixMap = resp.body.prefixes;
          Object.keys(this.dependencies).forEach(key => {
            this.dependencyTabs.push(new Tab(key, key, this.dependencies[key].length, false));
          });
        })
      ))
    ).subscribe();
  }

  onDownload(): void {
    this.isDownload = true;
  }
}
